import { atom } from 'jotai';
import { BreadcrumbProps } from 'antd';

export const headerBreadcrumbsAtom = atom<BreadcrumbProps['items'] | null>(null);
